import { render } from "./DetailArticle.vue?vue&type=template&id=2f5b6ddc"
import script from "./DetailArticle.vue?vue&type=script&lang=js"
export * from "./DetailArticle.vue?vue&type=script&lang=js"

import "./DetailArticle.vue?vue&type=style&index=0&id=2f5b6ddc&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__